/**
 * Import Lib & assets
 */

import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { CallGet } from "helpers/api/Helpers";
import { getUrl, isProductFromZodiac } from "helpers/zodiac";

import { ContentContext } from "context/contentContext";

/**
 * import components
 */

import { Content__rating, Content__popin } from "components/content/content";

/**
 * styled components
 */

/**
 * rating component is..
 */

const Item__rating = ({ id, name, centered }) => {
  const [rating, setRating] = useState(0);
  const [opinion, setOpinion] = useState(0);
  const [popIn, setPopIn] = useState(false);
  const { lang } = useContext(ContentContext);

  const onClick = () => {
    setPopIn(true);
  };

  const onClose = () => {
    setPopIn(false);
  };

  useEffect(() => {
    // check if id is one from Zodiac or one generated
    if (!isProductFromZodiac(id)) return setOpinion(0);
    const url = getUrl();
    CallGet(url, {
      language: lang,
      lltCode: id,
    }, {}).then(res => {
      if (!res.data) return;
      const infosKey = Object.keys(res.data).filter(key => key.startsWith("GlobalInfo"));      
      const index = res.data[infosKey];
      let infos = false;
      if(index){
        infos = res.data[infosKey][0];
      }
      if (!infos) return;
      
      setRating(parseInt(infos.GlobalScore));
      setOpinion(parseInt(infos.ReviewsCount));
    });
  }, []);
  if (lang === "pt") return <></>;
  return (
    <>
      <Content__rating rating={rating} opinion={opinion} onClick={onClick} centered={centered} />
      {popIn && <Content__popin id={id} name={name} lang={lang} onClose={onClose} />}
    </>
  );
};

export default Item__rating;

Item__rating.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Item__rating.defaultProps = {
  style: {},
};

/*
    import Item__rating from 'components/item/rating/item__rating'
    <Item__rating />
  */
